<template>
  <div class="v-collapse" :class="{ open }">
    <div class="v-collapse-content" :style="{ gridTemplateRows }">
      <div class="v-collapse-content--wrapper" ref="wrapper">
        <slot></slot>
      </div>
    </div>
    <button v-if="btn" @click="onToggle" class="v-collapse-button">
      <span>
        {{ open ? "View less" : "View more" }}
      </span>
      <i role="button" aria-label="Toggle" class="v-collapse-icon" v-icon:chevron-down></i>
    </button>
  </div>
</template>

<script>
export default {
  name: "VCollapse",
  data() {
    return {
      open: false,
      gridTemplateRows: "0.5fr",
      btn: true
    };
  },
  mounted() {
    this.setHeight();
    window.addEventListener("resize", this.setHeight)
  },
  methods: {
    setHeight() {
      const $c = 200;
      const $h = this.$refs['wrapper'].scrollHeight;
      this.gridTemplateRows = `${$h > $c ? ($c / $h) : 1}fr`
      this.btn = $h > $c;
    },
    onToggle() {
      this.open = !this.open;
    },
  },
};
</script>

<style lang="scss" scoped></style>
